(function () {
    'use strict';

    angular
        .module('app.alerts')
        .controller('AlertsController', AlertsController);

    AlertsController.$inject = ['$scope', 'common', 'dataservice',  'config', 'carousel.dialog', 'backendHubProxy'];
    /* @ngInject */
    function AlertsController($scope, common, dataservice, config, carouselDialog, backendHubProxy) {
        var vm = this;
        
        vm.title = "Alerts"
        vm.items = [];
        vm.isLoading = true;
        vm.onDate = common.getMainState("mainDate");
        vm.processAlert = processAlert;
        vm.hasBeenAcknowledged = hasBeenAcknowledged;
        vm.isNewAlert = isNewAlert;
        vm.refresh = getItems;
        vm.canEdit = canEdit;
        vm.showAttachments = showAttachments;

        $scope.$on('$destroy', function () {
            backendHubProxy.stop();
        });


        activate();

        function activate() {
            backendHubProxy.startListening();
            common.notifier.subscribe(common.config.events.mainDateChange, $scope, dateChanged);
            var promises = [getItems()];
            return common.$q.all(promises).then(function () {
                common.logger.info('Activated ' + vm.title + ' View');
                vm.isLoading = false;
                common.notifier.notify(config.events.refreshCounts);
            }, function (error) { });
        }

        function processAlert($event, alert) {  
            $event.preventDefault();
            $event.stopPropagation();
            dataservice.putItem("api/Alerts/AcknowledgeAlert/" + alert.ID);
            alert.AcknowledgedUtc = new Date();
            common.notifier.notify(config.events.refreshCounts);
        }

        function canEdit(item) {
            if (common.userService.userType() == "0") {
                return common.userService.userId() == item.CreatedById;
            }
            else {
                return true;
            }
        }

        function showAttachments(i, $event) {
            $event.preventDefault();
            $event.stopPropagation();
            var title = i.Description;
            return dataservice.getItems('api/Attachments/GetForParentType/7/' + i.ID).then(function (response) {
                return carouselDialog.display(response.data).then(function () { }, function () { });
            }, function (error) { });
        }

        

        function getItems() {
            var m = moment(common.buildDateTime(vm.onDate, new Date())).toISOString();
            
            
            return dataservice.getItems('api/Alerts/GetForDate?localDate=' + m).then(function (response) {
                vm.items = response.data;
                //common.convertDateStringsToDates(vm.items);
                vm.displayedItems = [].concat(vm.items);
                backendHubProxy.items = vm.items;
                backendHubProxy.displayedItems = vm.displayedItems;
                return vm.items;
            }, function (error) { });
        }


        function dateChanged(eventName, newDate) {
            vm.onDate = newDate;
            getItems();
        }

        function hasBeenAcknowledged(item) {
            return item.AcknowledgedUtc;
        }

        function isNewAlert(item) {
            return !item.AcknowledgedUtc;
        }

    }
})();
